<template>
	<v-container class="pt-0" v-if="details">
		<v-card elevation="0" class="ant-card px-4 pb-2">
			<v-card-title class="pa-0">
				<v-col cols="auto" class="d-flex align-center">
					<div class="v-typography--title1">{{ $t("stock_details") }}</div>
				</v-col>
				<v-spacer />
				<v-col cols="auto" class="d-flex justify-end px-0">
					<v-btn text outlined @click="openEditDialog">
						<v-icon size="15">icon-edit</v-icon>
						<span class="ml-1 v-typography--body-sm">{{ $t("edit") }}</span>
					</v-btn>
				</v-col>
			</v-card-title>
			<v-divider class="mb-4" />

			<v-row class="px-4">
				<v-col cols="12" sm="6">
					<info-section icon="icon-document" :title="$t('lot_no')" :content="details.lotNo" />
				</v-col>
				<v-col cols="12" sm="6">
					<info-section icon="icon-products" :title="$t('product')" :content="details.productName" />
				</v-col>
			</v-row>

			<v-row class="px-4">
				<v-col cols="12" sm="6">
					<info-section icon="icon-company-profile" :title="$t('warehouse')" :content="details.warehouseName" />
				</v-col>
				<v-col cols="12" sm="6">
					<info-section icon="icon-attributes" :title="$t('attributes')" :content="details.attributes" />
				</v-col>
			</v-row>

			<v-row class="px-4">
				<v-col cols="12" sm="6">
					<info-section
						icon="icon-plus-bag"
						:title="$t('total')"
						:content="`${details.totalQuantity} ${details.quantityUnit}`"
					/>
				</v-col>
			</v-row>
		</v-card>

		<new-stock-dialog
			v-model="editDialogVisible"
			:stockData="details"
			:companyId="details.companyId"
			:unitCode="details.quantityUnit"
			@saved="onEdited"
		/>
	</v-container>
</template>

<script>
import InfoSection from "./InfoSection.vue";
import NewStockDialog from "../stocks/dialogs/NewStockDialog.vue";

export default {
	name: "StockDetails",

	components: { InfoSection, NewStockDialog },

	props: {
		details: { type: Object, required: true },
	},

	data() {
		return {
			editDialogVisible: false,
			bundle: null,
			unitOptions: [],
			stockData: null,
		};
	},

	methods: {
		openEditDialog() {
			this.editDialogVisible = true;
		},
		async onEdited() {
			this.$emit("refresh");
			this.editDialogVisible = false;
		},
	},
};
</script>
